
export enum GameUpdate {
    FirstGameState = 1, // Must be sent at the start of the game before any other state
    // KickedFromGame = 3,
    BuildGame = 4,
    TogglePauseGame = 5,
    CanResignGame = 6,
    // ChatGameLog = 7,
    // InitialPlacement = 8,
    // CurrentGameState = 9,
    // BankState = 10,
    // DiceState = 11,
    PlayerControllerState = 12,
    AmountOfCardsToDiscard = 13,
    // MapState = 14,
    // MapEdges = 15,
    // MapCorners = 16,
    // MapTiles = 17,
    CardsToSelectForDevelopmentCard = 18,
    CardsToSelectForPendingTransaction = 19,
    SelectPlayerUsingDevelopmentCard = 20,
    ConfirmUseDevelopmentCard = 21,
    StealDevelopmentCardFromPlayer = 22,
    StealResourceCardFromPlayer = 23,
    SelectPlayerAndCard = 24,
    SelectCardsToGiveToPlayer = 25,
    SelectDice = 26,
    ClosePopupUI = 27,
    GivePlayerResourcesFromTile = 28,
    SelectPlayer = 29,
    HighlightCorners = 30,
    HighlightRoadEdges = 31,
    HighlightShipEdges = 32,
    HighlightTiles = 33,
    HighlightDiceNumbersForInventor = 34,
    // BankTradeRatioState = 35,
    TradeState = 36,
    TradeResponseState = 37,
    EmbargoState = 38,
    BoldTextInTradeWindow = 39,
    CloseOffer = 40,
    // OfferError = 41,
    InfoMessage = 42,
    ExchangeCards = 43,
    GameSettings = 44,
    GameEndState = 45,
    RematchLink = 46,
    EndGameText = 47,
    SpectatorData = 48,
    // PlayersCanceledSpecialBuildPhase = 49,
    // SpecialBuildPhaseLastPlayerToRollDice = 50,
    Vote = 51,
    CityImprovementStateUpdated = 52,
    ForceShowCityImprovementButtons = 53,
    // UnlockedCityImprovement = 54,
    // PlayerReceivedMetropolis = 55,
    // KnightPieceStateUpdated = 56,
    // BarbarianStateUpdated = 57,
    MerchantStateUpdates = 58,
    PlayTurnSound = 59,
    PlayersTakingAction = 60,
    PlayersDoneTakingAction = 61,
    ExitInitialPlacement = 62,
    TradeFinalized = 63,
    TradeRejectedByAll = 64,
    KnightPlaced = 65,
    KnightActivated = 66,
    KnightUpgraded = 67,
    PlayerDisconnected = 68,
    PlayerReconnected = 69,
    DiscardBroadcast = 70,
    // PlayCityImprovementSound = 71,
    // PlayAchievementCKProgressSound = 72,
    SpectatorChatMessage = 73,
    SendBroadcast = 74,
    TradeEmbargoState = 75,
    Ping = 76,
    BeginnerHintActivated = 77,
    KarmaState = 78,
    StressTestLagTest = 79,
    ResetTradeStateAtEndOfTurn = 80,
    ClosedTradeStates = 81,
    // GivePlayerGrantedCards = 82,
    // TradePlayersCreatingCounterOfferState = 83,
    // GameInfo = 84,
    // ChatTextHistory = 85,
    // ChatGameLogHistory = 86,
    BeginnerModeActionUpdate = 87,
    BeginnerModeLevelEnd = 88,
    ResetBeginnerModeLevel = 89,
    TriggerClientGameStateReset = 90,
    GameStateUpdated = 91,
    ReplayData = 92,
    EndOfInitialPlacement = 93,
}

export interface GameUpdateData {
    type: GameUpdate
    payload: unknown
    sequence: number
}
